// #region Dependencias
import { HexColorInput, HexColorPicker } from 'react-colorful'
import styled from 'styled-components'
import { Form } from 'components/Library'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledHexColorPicker = styled(HexColorPicker)`
  margin-bottom: 1rem;
  width: 100% !important;
`

const StyledHexColorInput = styled(HexColorInput)`
  background-color: transparent;
  display: block;
  border: 2px solid ${colors.primary};
  border-radius: 0.5rem;
  padding: 1rem;
  text-transform: uppercase;
  width: 100%;
`
// #endregion

/**
 * Componente que maneja la edición de color de landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.color - Color actual de la aplicación.
 * @param {Function} props.setValues - Callback para actualizar los valores del formulario de la página directamente.
 */
const MenuColor = ({ color, setValues }) => {
  /**
   * Función que maneja la edición de color del componente.
   * @param {string} valor - Color editado del componente.
   */
  const handleChange = (valor) => {
    setValues((values) => ({
      ...values,
      opciones: {
        ...values.opciones,
        colores: {
          ...values.opciones.colores,
          primario: valor
        }
      }
    }))
  }

  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <StyledHexColorPicker color={color} onChange={handleChange} />
      <StyledHexColorInput
        name="opciones.colores.primario"
        color={color}
        onChange={handleChange}
        prefixed
      />
    </Form>
  )
}

export default MenuColor
